/** Measure aggregation applied to a pivot value field. */
export enum PivotAggregationEnum {
  Sum = 'Sum',
  Count = 'Count',
  DistinctCount = 'DistinctCount',
  Average = 'Average',
  Max = 'Max',
  Min = 'Min',
}
